import * as React from "react";

function SvgSettingsFilter({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M20 2.75a1.75 1.75 0 011.744 1.607l.006.143v2.532c0 .462-.182.902-.503 1.228l-.127.116-6.37 5.308v4.198c0 .561-.268 1.082-.71 1.407l-.125.084-.133.074-2.724 1.362a1.25 1.25 0 01-1.803-.999l-.005-.119v-6.006L2.88 8.376a1.748 1.748 0 01-.596-1.003l-.026-.17-.008-.171V4.5a1.75 1.75 0 011.607-1.744L4 2.75h16zm-1.073 5.5H5.072l5.408 4.507a.75.75 0 01.262.466l.008.11v5.952l2.362-1.18a.251.251 0 00.114-.116l.018-.052.006-.055v-4.549c0-.185.069-.363.19-.5l.08-.076 5.407-4.507zm1.073-4H4a.25.25 0 00-.243.193L3.75 4.5v2.25h16.5V4.5a.25.25 0 00-.193-.243L20 4.25z"
        />
      </g>
    </svg>
  );
}

export default SvgSettingsFilter;
